"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const details = [{
    label: "NORTH AMERICA HQ",
    lines: ["11375 Pochard way", "San Diego, CA 92131", "United States"]
  }, {
    label: "SALES SUPPORT",
    lines: ["+1 (858) 524-9057"]
  }, {
    label: "DIRECT EMAIL",
    lines: ["rkim@gstna.com"]
  }, {
    label: "MEXICO OPERATIONS",
    lines: ["Parque Industrial Girasol 2", "Tijuana, BC 22215", "Mexico"]
  }];
  return <section data-section-id="1392" id="regional-sales-offices" className="bg-[#F8F5F8] text-[#442872] py-28 md:py-36 px-6 md:px-16 lg:px-24">
      <div ref={ref} className="mx-auto max-w-[1440px] grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(16px)",
      transition: "opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1)"
    }}>
        {}
        <div className="lg:col-span-7 relative">
          <div className="relative w-full h-[360px] md:h-[520px] lg:h-[640px]">
            {}
            <span aria-hidden="true" className="absolute top-0 left-0 w-3 h-3 border-t border-l" style={{
            borderColor: "#442872",
            borderWidth: "1px"
          }} />
            <span aria-hidden="true" className="absolute top-0 right-0 w-3 h-3 border-t border-r" style={{
            borderColor: "#442872",
            borderWidth: "1px"
          }} />
            <span aria-hidden="true" className="absolute bottom-0 left-0 w-3 h-3 border-b border-l" style={{
            borderColor: "#442872",
            borderWidth: "1px"
          }} />
            <span aria-hidden="true" className="absolute bottom-0 right-0 w-3 h-3 border-b border-r" style={{
            borderColor: "#442872",
            borderWidth: "1px"
          }} />

            {}
            <svg viewBox="0 0 700 600" preserveAspectRatio="xMidYMid slice" className="w-full h-full" aria-label="Stylized map of North American operations">
              {}
              <rect width="700" height="600" fill="#F8F5F8" />

              {}
              <g stroke="#442872" strokeOpacity="0.35" strokeWidth="1" fill="none">
                {}
                <line x1="0" y1="90" x2="700" y2="90" />
                <line x1="0" y1="180" x2="700" y2="180" />
                <line x1="0" y1="270" x2="700" y2="270" />
                <line x1="0" y1="360" x2="700" y2="360" />
                <line x1="0" y1="450" x2="700" y2="450" />
                <line x1="0" y1="540" x2="700" y2="540" />

                {}
                <line x1="80" y1="0" x2="80" y2="600" />
                <line x1="190" y1="0" x2="190" y2="600" />
                <line x1="310" y1="0" x2="310" y2="600" />
                <line x1="430" y1="0" x2="430" y2="600" />
                <line x1="540" y1="0" x2="540" y2="600" />
                <line x1="630" y1="0" x2="630" y2="600" />

                {}
                <line x1="190" y1="90" x2="310" y2="180" />
                <line x1="430" y1="360" x2="540" y2="450" />
              </g>

              {}
              <g fill="#442872" fillOpacity="0.06" stroke="#442872" strokeOpacity="0.25" strokeWidth="0.5">
                <rect x="90" y="100" width="90" height="70" />
                <rect x="200" y="100" width="100" height="70" />
                <rect x="320" y="100" width="100" height="70" />
                <rect x="440" y="100" width="90" height="70" />
                <rect x="90" y="190" width="90" height="70" />
                <rect x="200" y="190" width="100" height="70" />
                <rect x="320" y="190" width="100" height="70" />
                <rect x="440" y="190" width="90" height="70" />
                <rect x="90" y="280" width="90" height="70" />
                <rect x="200" y="280" width="100" height="70" />
                <rect x="440" y="280" width="90" height="70" />
                <rect x="550" y="280" width="70" height="70" />
                <rect x="90" y="370" width="90" height="70" />
                <rect x="200" y="370" width="100" height="70" />
                <rect x="320" y="370" width="100" height="70" />
                <rect x="440" y="370" width="90" height="70" />
                <rect x="90" y="460" width="90" height="70" />
                <rect x="320" y="460" width="100" height="70" />
                <rect x="440" y="460" width="90" height="70" />
                <rect x="550" y="460" width="70" height="70" />
              </g>

              {}
              <rect x="320" y="280" width="100" height="70" fill="#442872" fillOpacity="0.08" stroke="#442872" strokeWidth="1" />

              {}
              <g fill="#80729B" fontFamily="var(--font-mono)" fontSize="9" letterSpacing="1.8">
                <text x="90" y="85" textAnchor="start">NORTH_REGION</text>
                <text x="90" y="265" textAnchor="start">CENTRAL_HUB</text>
                <text x="90" y="445" textAnchor="start">SOUTH_CORRIDOR</text>
                <text x="195" y="595" textAnchor="start">WEST_ZONE</text>
                <text x="435" y="595" textAnchor="start">EAST_ZONE</text>
              </g>

              {}
              <line x1="370" y1="315" x2="540" y2="200" stroke="#442872" strokeWidth="1" />

              {}
              <g>
                <circle cx="370" cy="315" r="8" fill="#442872" fillOpacity="0.2">
                  <animate attributeName="r" values="8;14;8" dur="2s" repeatCount="indefinite" />
                  <animate attributeName="fill-opacity" values="0.3;0.05;0.3" dur="2s" repeatCount="indefinite" />
                </circle>
                <circle cx="370" cy="315" r="4" fill="#442872">
                  <animate attributeName="fill-opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite" />
                </circle>
              </g>

              {}
              <circle cx="540" cy="200" r="2" fill="#442872" />

              {}
              <text x="548" y="197" fill="#442872" fontFamily="var(--font-mono)" fontSize="10" letterSpacing="1.8">
                GST_CHICAGO
              </text>
              <text x="548" y="212" fill="#80729B" fontFamily="var(--font-mono)" fontSize="9" letterSpacing="1.6">
                NA_HEADQUARTERS
              </text>
            </svg>
          </div>
        </div>

        {}
        <div className="lg:col-span-5 lg:pl-12 flex flex-col justify-center">
          {}
          <div className="flex items-center gap-3 mb-8">
            <span aria-hidden="true" className="inline-block w-1 h-1" style={{
            backgroundColor: "#442872"
          }} />
            <span className="font-mono uppercase text-[11px] md:text-[13px]" style={{
            color: "#442872",
            letterSpacing: "0.18em"
          }}>
              Nº 04 — Regional Presence
            </span>
          </div>

          {}
          <h2 className="font-default text-[#442872] mb-8" style={{
          fontSize: "clamp(2.25rem, 4.5vw, 3.75rem)",
          fontWeight: 600,
          letterSpacing: "-0.02em",
          lineHeight: 1.04
        }}>
            Precision manufacturing across{" "}
            <em className="font-default italic" style={{
            color: "#442872"
          }}>
              North America
            </em>
            .
          </h2>

          {}
          <p className="text-[#442872]/80 mb-12" style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.005em"
        }}>
            Global Standard Technology operates high-efficiency facilities designed for precision die-cutting, slitting, and laminating. Our North American footprint ensures rapid response times for automotive, aerospace, and electronics manufacturers, maintaining strict quality standards across every production line.
          </p>

          {}
          <div className="flex flex-col">
            {details.map((detail, i) => <div key={i} data-index={i} className="py-5 first:pt-0">
                {}
                {i > 0 && <div className="relative -mt-5 mb-5 flex items-center">
                    <div className="flex-1 h-px" style={{
                backgroundColor: "#442872"
              }} />
                    <span aria-hidden="true" className="inline-block w-1 h-1 ml-1" style={{
                backgroundColor: "#442872"
              }} />
                  </div>}
                <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-2 md:gap-6">
                  <span className="font-mono uppercase text-[11px] pt-1" style={{
                color: "#442872",
                letterSpacing: "0.18em"
              }}>
                    {detail.label}
                  </span>
                  <div className="flex flex-col gap-0.5">
                    {detail.lines.map((line, j) => <span key={j} className="font-default text-[#442872]" style={{
                  fontSize: "15px",
                  lineHeight: 1.55
                }}>
                        {line}
                      </span>)}
                  </div>
                </div>
              </div>)}
            {}
            <div className="relative mt-2 flex items-center">
              <div className="flex-1 h-px" style={{
              backgroundColor: "#442872"
            }} />
              <span aria-hidden="true" className="inline-block w-1 h-1 ml-1" style={{
              backgroundColor: "#442872"
            }} />
            </div>
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 mt-10">
            <Link to="/ContactPage" className="group relative inline-flex items-center gap-2 font-default text-[#442872]" style={{
            fontSize: "15px"
          }}>
              
            </Link>
            <Link to="/ContactPage" className="group relative inline-flex items-center gap-2 font-default text-[#442872]" style={{
            fontSize: "15px"
          }}>
              <span className="relative"><span className="!text-[25px]"><Link className="underline cursor-pointer" href="https://wa.me/526644166474" newTab><span>Connect via WhatsApp →</span></Link></span><span aria-hidden="true" className="absolute left-0 -bottom-0.5 h-px w-0 group-hover:w-full" style={{
                backgroundColor: 'rgb(68, 40, 114)',
                transition: 'width 250ms ease-out'
              }}></span></span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}